var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "lit", "lit/directives/unsafe-html.js", "html-dom-parser", "katex"], function (require, exports, lit_1, unsafe_html_js_1, html_dom_parser_1, katex_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PropertyQuantity = exports.DefaultHTMLRenderer = exports.PropertyText = exports.PropertyStructuredText = exports.ResultProperty = exports.PropertyInfo = exports.RecordValue = exports.ListValue = exports.PrimitiveValue = exports.ValueTypeName = exports.RenderContext = void 0;
    exports.parsePropertiesFromPropertiesModel = parsePropertiesFromPropertiesModel;
    exports.parsePropertiesFromPropertyDataSet = parsePropertiesFromPropertyDataSet;
    exports.addActionsToTextExtracts = addActionsToTextExtracts;
    exports.createResultPropertiesFromPropertiesModel = createResultPropertiesFromPropertiesModel;
    exports.createResultPropertiesFromPropertiesData = createResultPropertiesFromPropertiesData;
    exports.parseTextRegionFromAnswerResultText = parseTextRegionFromAnswerResultText;
    html_dom_parser_1 = __importDefault(html_dom_parser_1);
    katex_1 = __importDefault(katex_1);
    ;
    const RenderContextOptionsDefaults = {};
    class RenderContext {
        constructor(options, propertyValueType) {
            this.options = options || Object.assign({}, RenderContextOptionsDefaults);
            this.propertyValueType = propertyValueType;
        }
        copyWithOptions(options) {
            const effectiveOptions = Object.assign({}, this.options, options);
            return new RenderContext(effectiveOptions, this.propertyValueType);
        }
    }
    exports.RenderContext = RenderContext;
    //type ValueTypeName = ValueTypeName;
    var ValueTypeName;
    (function (ValueTypeName) {
        ValueTypeName["Text"] = "text";
        ValueTypeName["StructuredText"] = "structuredtext";
        ValueTypeName["String"] = "string";
        ValueTypeName["Number"] = "number";
        ValueTypeName["Date"] = "date";
        ValueTypeName["Action"] = "action";
        ValueTypeName["NamedAction"] = "namedaction";
        ValueTypeName["Link"] = "link";
        ValueTypeName["Image"] = "image";
        ValueTypeName["Quantity"] = "quantity";
        ValueTypeName["TextSnippet"] = "textsnippet";
        ValueTypeName["TextSnippets"] = "textsnippets";
        ValueTypeName["PropertySet"] = "propertyset";
        ValueTypeName["List"] = "list";
        ValueTypeName["Empty"] = "empty";
        ValueTypeName["HtmlOnly"] = "htmlonly";
        ValueTypeName["Any"] = "any";
        ValueTypeName["TextExtracts"] = "textextracts";
        ValueTypeName["TextExtract"] = "textextract";
    })(ValueTypeName || (exports.ValueTypeName = ValueTypeName = {}));
    // @see Mindbreeze.WellknownProperties
    const WellknownPropertyValueTypes = {
        category: ValueTypeName.String,
        categoryinstance: ValueTypeName.String,
        "mes:key": ValueTypeName.String,
        fqcategory: ValueTypeName.String,
        title: ValueTypeName.Text,
        "mes:date": ValueTypeName.Date,
        actions: ValueTypeName.Action,
        "mes:summary": ValueTypeName.PropertySet,
        "mes:nested": ValueTypeName.PropertySet,
        sourcedocindex: ValueTypeName.Number,
        "mes:uniformdocid": ValueTypeName.Number,
        "citationdocumentnumber": ValueTypeName.String,
        "sourcefragmentpos": ValueTypeName.Number,
        "textsnippets": ValueTypeName.TextSnippet,
        "textExtracts": ValueTypeName.TextExtracts,
        "citationid": ValueTypeName.String,
        icon: ValueTypeName.Text
    };
    function getRenderFunction(renderer, valueTypeName) {
        var _a, _b;
        const methodMap = {
            [ValueTypeName.Text]: "renderText",
            [ValueTypeName.StructuredText]: "renderStructuredText",
            [ValueTypeName.String]: "renderString",
            [ValueTypeName.Number]: "renderNumber",
            [ValueTypeName.Date]: "renderDate",
            [ValueTypeName.Action]: "renderAction",
            [ValueTypeName.NamedAction]: "renderNamedAction",
            [ValueTypeName.Link]: "renderLink",
            [ValueTypeName.Image]: "renderImage",
            [ValueTypeName.Quantity]: "renderQuantity",
            [ValueTypeName.PropertySet]: "renderPropertySet",
            [ValueTypeName.List]: "renderList",
            [ValueTypeName.TextExtracts]: "renderList",
            [ValueTypeName.TextExtract]: "renderTextExtract",
            [ValueTypeName.Empty]: "renderUnknown",
            [ValueTypeName.HtmlOnly]: "renderStructuredText",
            [ValueTypeName.Any]: "renderUnknown",
        };
        const methodName = (_a = methodMap[valueTypeName]) !== null && _a !== void 0 ? _a : "renderUnknown";
        const method = (_b = renderer[methodName]) !== null && _b !== void 0 ? _b : renderer.renderUnknown;
        if (typeof method !== "function") {
            console.warn(`Renderer does not implement "${String(methodName)}" or "renderUnknown"`);
            return () => null; // no-op fallback
        }
        return method.bind(renderer);
    }
    // We could create a Prerendered<T>
    // the primitive case might have html representation from the
    // backend
    class PrimitiveValue {
        constructor(structuredText, value, valueTypeName, options) {
            this.structuredText = structuredText;
            this.value = value;
            this.valueTypeName = valueTypeName;
        }
        render(context, renderer) {
            var _a;
            if (!(((_a = context === null || context === void 0 ? void 0 : context.options) === null || _a === void 0 ? void 0 : _a.forceRerenderValue) && this.value) && this.html) {
                return renderer.renderStructuredText(context, this.structuredText);
            }
            else if (this.value && this.valueTypeName) {
                let outerPropertyValueType = context.propertyValueType;
                context.propertyValueType = this.valueTypeName;
                const renderResult = getRenderFunction(renderer, this.valueTypeName)(context, this.value);
                context.propertyValueType = outerPropertyValueType;
                return renderResult;
            }
        }
    }
    exports.PrimitiveValue = PrimitiveValue;
    class ListValue {
        constructor(values, elementType) {
            this.elementValues = values;
            this.elementTypeName = elementType || ValueTypeName.Any;
        }
        get value() {
            return this.elementValues.map(propValue => propValue === null || propValue === void 0 ? void 0 : propValue.value);
        }
        get length() {
            return this.elementValues.length;
        }
        render(context, renderer) {
            return renderer.renderList(context, this, this.elementTypeName);
        }
    }
    exports.ListValue = ListValue;
    class RecordValue {
        constructor(value, elementType) {
            this.valueType = ValueTypeName.PropertySet;
            this.value = value;
            this.elementType = elementType;
        }
        render(context, renderer) {
            return renderer.renderProperties(context, this.value);
        }
    }
    exports.RecordValue = RecordValue;
    class PropertyInfo {
        constructor({ key, label }) {
            this.key = key;
            this.label = label;
        }
    }
    exports.PropertyInfo = PropertyInfo;
    class ResultProperty extends PropertyInfo {
        constructor({ key, label, value }) {
            super({ key, label });
            this.accessor = value;
        }
        get value() {
            return this.accessor.value;
        }
        renderValue(context, renderer) {
            return this.accessor.render(context, renderer);
        }
        render(context, renderer) {
            return renderer.renderProperty(context, this, this.accessor);
        }
    }
    exports.ResultProperty = ResultProperty;
    class PropertyStructuredText {
        constructor(value) {
            this.content = (0, html_dom_parser_1.default)(value);
        }
    }
    exports.PropertyStructuredText = PropertyStructuredText;
    class PropertyText {
        constructor(value) {
            this.plainText = value;
            this.structuredText = new PropertyStructuredText(value);
        }
    }
    exports.PropertyText = PropertyText;
    const SIMPLE_VALUE_KEYS = ["category", "categoryinstance", "mes:key", "title", "mes:date", "mes:uniformdocid"];
    class DefaultHTMLRenderer {
        renderProperties(context, properties) {
            let sep = (0, lit_1.html) `<span>, </span>`;
            return (0, lit_1.html) `${Object.keys(properties).map((propertyKey, index) => {
                return (0, lit_1.html) `${index > 0 ? sep : lit_1.nothing}${properties[propertyKey].render(context, this)}`;
            })}`;
        }
        renderProperty(context, propertyInfo, valueAccess) {
            return (0, lit_1.html) `<span class="property-label">${propertyInfo.label}:</span> <span class="property-value">${valueAccess.render(context, this)}</span>`;
        }
        renderList(context, list, elementType) {
            // the idea is that we call thex list
            let sep = (0, lit_1.html) `<span>, </span>`;
            if (elementType == ValueTypeName.NamedAction) {
                sep = (0, lit_1.html) `<span class="action-separator">  </span>`;
            }
            return (0, lit_1.html) `${list.elementValues.map((valueAccessor, index) => {
                return (0, lit_1.html) `${index > 0 ? sep : null}${valueAccessor.render(context, this)}`;
            })}`;
        }
        renderNamedAction(context, action) {
            const wrapLink = (link, label) => {
                return (0, lit_1.html) `<a href="${link.href}">${label}</a>`;
            };
            const wrapAction = (action, label) => {
                return (0, lit_1.html) `<a class="action" data-action-object="${JSON.stringify(action)}">${label}</a>`;
            };
            if (action.valueType == ValueTypeName.Link) {
                return wrapLink(action, action.label);
            }
            else if (action.valueType == ValueTypeName.Action) {
                return wrapAction(action.action, action.label);
            }
            return;
        }
        renderLink(context, link) {
            return (0, lit_1.html) ``;
        }
        renderImage(context, link) {
            return (0, lit_1.html) `<img src="${link.href}">`;
        }
        renderTextExtract(context, textExtract) {
            if (textExtract.typeName === 'textregion') {
                return this.renderTextRegion(context, textExtract);
            }
            else if (textExtract.typeName === 'textsnippets') {
                return this.renderStructuredText(context, textExtract === null || textExtract === void 0 ? void 0 : textExtract.content);
            }
            return this.renderUnknownTextExtract(context, textExtract);
        }
        renderTextExtracts(context, textExtracts) {
            for (const textExtract of textExtracts.items) {
                return this.renderTextExtract(context, textExtract);
            }
        }
        renderUnknownTextExtract(context, textExtracts) {
            return (0, lit_1.html) `
      <div>${textExtracts.typeName}</div>
    `;
        }
        renderTextRegion(context, textRegion) {
            var _a, _b, _c, _d, _e, _f, _g;
            let showContext = (textRegion.contextBefore || textRegion.contextAfter) != undefined;
            let maxChars = Number((_e = (_d = (_c = (_b = (_a = context === null || context === void 0 ? void 0 : context.options) === null || _a === void 0 ? void 0 : _a.themeDescriptor) === null || _b === void 0 ? void 0 : _b.widgets) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.snippet) === null || _e === void 0 ? void 0 : _e.highlightMaxChars);
            // @TODO, consider checing plainText or structuredText length
            if (maxChars && ((_g = (_f = textRegion.text) === null || _f === void 0 ? void 0 : _f.plainText) === null || _g === void 0 ? void 0 : _g.trim().length) > maxChars) {
                showContext = false;
            }
            return (0, lit_1.html) `
    <div>
      ${textRegion.contextBefore && showContext ? (0, lit_1.html) `<span>${this.renderText(context, textRegion.contextBefore)}</span>` : lit_1.nothing}
      <em style="${showContext ? "font-weight: bold" : ""}"> 
        ${this.renderText(context, textRegion.text)}
      </em>
      ${textRegion.contextAfter && showContext ? (0, lit_1.html) `<span>${this.renderText(context, textRegion.contextAfter)}</span>` : lit_1.nothing}
    </div>
    `;
        }
        renderTextSnippets(context, textSnippets) {
            return this.renderStructuredText(context, textSnippets.content);
        }
        renderDate(context, date) {
            return (0, lit_1.html) `${date.toLocaleDateString()}`;
        }
        renderQuantity(context, quantity) {
            return (0, lit_1.html) ``;
        }
        renderString(context, text) {
            return (0, lit_1.html) `${text}`;
        }
        renderNumber(context, num) {
            return (0, lit_1.html) ``;
        }
        renderUnknown(context, value) {
            return (0, lit_1.html) ``;
        }
        renderText(context, value) {
            if (value.structuredText) {
                return this.renderStructuredText(context, value.structuredText);
            }
            else if (value.plainText) {
                return this.renderString(context, value.plainText);
            }
        }
        toHtml(node) {
            if (node.type === 'text') {
                return node.data;
            }
            if (node.type === 'tag') {
                const children = (node.children || [])
                    .map((n) => this.toHtml(n))
                    .join('');
                const attrs = node.attribs || {};
                const attrString = Object.entries(attrs)
                    .map(([k, v]) => `${k}="${v}"`)
                    .join(' ');
                return `<${node.name}${attrString ? ' ' + attrString : ''}>${children}</${node.name}>`;
            }
            return '';
        }
        renderStructuredText(context, value) {
            const htmlString = value.content
                .map((node) => this.toHtml(node))
                .join('');
            return (0, lit_1.html) `${(0, unsafe_html_js_1.unsafeHTML)(htmlString)}`;
        }
    }
    exports.DefaultHTMLRenderer = DefaultHTMLRenderer;
    class PropertyQuantity extends Number {
        constructor(value, unit) {
            super(value);
        }
    }
    exports.PropertyQuantity = PropertyQuantity;
    function extractValueTypeFromValue(data, key, options) {
        let valueType;
        let structuredText;
        if (data.html) {
            structuredText = { content: (0, html_dom_parser_1.default)(data.html, options) };
        }
        if ("value" in data) {
            // we have value.
            //data.value.
            // TODO use the WellknownPropertyTypeNames object to find a knownValueType for the key
            const knownValueTypeName = WellknownPropertyValueTypes[key];
            const value = data.value;
            if (typeof value == "number") {
                valueType = ValueTypeName.Number;
                return { valueType, value };
            }
            else if (typeof value == "string") {
                valueType = ValueTypeName.Text;
                if (knownValueTypeName == ValueTypeName.String) {
                    return { valueType, value };
                }
                else if (knownValueTypeName != null && knownValueTypeName != ValueTypeName.Text) {
                    console.warn("TypeValueName should be Text, but found: " + knownValueTypeName);
                }
                return { valueType, value: { plainText: value, structuredText }, structuredText };
            }
            else if (typeof value == "object") {
                if (value instanceof Date) {
                    valueType = ValueTypeName.Date;
                    return { valueType, value };
                }
                if ("unit" in value && "num" in value) {
                    valueType = ValueTypeName.Quantity;
                    return { valueType, value: new PropertyQuantity(value.num, value.unit) };
                }
                else if ("num" in value) {
                    valueType = ValueTypeName.Number;
                    return { valueType, value: Number(value.num) };
                }
                if ("href" in value) {
                    valueType = ValueTypeName.Link;
                    if ("rel" in value) {
                        if (value.rel.indexOf("image") >= 0) {
                            valueType = ValueTypeName.Image;
                        }
                    }
                    return { valueType, value };
                }
                // question `action` value can be also a link
                else if ("action" in value) {
                    // PropertyVactionValue;
                    valueType = ValueTypeName.Action;
                    return { valueType, value };
                }
                else if ("str" in value) {
                    valueType = ValueTypeName.Text;
                    if (knownValueTypeName == ValueTypeName.String) {
                        return { valueType, value };
                    }
                    else if (knownValueTypeName != null && knownValueTypeName != ValueTypeName.Text) {
                        console.warn("TypeValueName should be Text, but found: " + knownValueTypeName);
                    }
                    // @ts-ignore @todo defne type str
                    return { valueType, value: { plainText: value.str, structuredText }, structuredText };
                }
                else if ("textRegion" in value) {
                    valueType = ValueTypeName.TextExtract;
                    return { valueType, value: value === null || value === void 0 ? void 0 : value.textRegion };
                }
            }
        }
        else if ("properties" in data) {
            // structured record can also happen at the
            // data level. data: { properties: [] }
            valueType = ValueTypeName.PropertySet;
            return { valueType, value: parsePropertiesFromPropertyDataSet(data.properties) };
        }
        else if ("html" in data) {
            valueType = ValueTypeName.HtmlOnly;
            return { valueType, value: structuredText, structuredText };
        }
        // return {valueType, value: data}
        return { valueType: ValueTypeName.Any };
    }
    function parsePropertiesFromPropertiesModel(model, options) {
        return parsePropertiesFromPropertyDataSet(model.properties, options);
    }
    // TODO make unit test
    function parsePropertiesFromPropertyDataSet(properties, options) {
        var _a, _b;
        let result = {};
        const items = Array.isArray(properties) ? properties : Object.keys(properties);
        for (let i = 0; i < items.length; ++i) {
            const prop = Array.isArray(properties) ? properties[i] : properties[items[i]];
            if (typeof prop != "object") {
                // skip simple types initially
                continue;
            }
            let key = prop.id || items[i];
            let shouldDuplicateResultProperty;
            const name = prop.name;
            let valueType;
            let propertyInfo;
            // TODO extract this from the wellnownproperties
            const asList = (key == "actions" || key == "textExtracts");
            if (key == "content" && ("data" in prop && ((prop.data.length == 1 && prop.data[0].html)) || Array.isArray(prop.properties) && prop.properties && prop.properties.length == 1 && prop.properties[0].data.length == 1 && prop.properties[0].data[0].html)) {
                // additional extract "content" as textsnippet.
                // TODO differentiate html StructuredText from Answers1
                //  Answers is potentially special cased as it is not part of the ResultProperties
                const htmlText = ((_b = (_a = prop.data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.html) ? prop.data[0].html : prop.properties[0].data[0].html;
                const structuredText = { content: (0, html_dom_parser_1.default)(htmlText, options) };
                const textSnippets = { typeName: ValueTypeName.TextSnippets, content: structuredText };
                let values = [
                    new PrimitiveValue(structuredText, { propertyName: "content", value: textSnippets }, ValueTypeName.TextExtracts, options)
                ];
                if (key === 'content') {
                    shouldDuplicateResultProperty = 'content';
                }
                key = 'textExtracts';
                result[key] = new ResultProperty({ key, label: key, value: new ListValue(values) });
            }
            if (key == "actions" && "properties" in prop) {
                // first try to use properties
                const value = parsePropertiesFromPropertyDataSet(prop.properties, options);
                const actionKeys = Object.keys(value);
                const namedActions = actionKeys.map(key => {
                    const actionProp = value[key];
                    const valueType = actionProp.accessor.valueTypeName;
                    if (typeof actionProp.value == "object" && ("action" in actionProp.value || "href" in actionProp.value)) {
                        let html = actionProp.accessor instanceof PrimitiveValue ? actionProp.accessor.html : undefined;
                        return new PrimitiveValue(html, Object.assign({ key, label: actionProp.label, valueType }, actionProp.value), ValueTypeName.NamedAction, options);
                    }
                }).filter(item => item);
                ;
                result[key] = new ResultProperty({ key, label: prop.name, value: new ListValue(namedActions, ValueTypeName.NamedAction) });
                continue;
            }
            if ("data" in prop) {
                let elementTypeName;
                let elementValueAndTypes = prop.data.map((datum) => extractValueTypeFromValue(datum, key, options));
                if (elementValueAndTypes.length == 0) {
                    valueType = ValueTypeName.Empty;
                    elementValueAndTypes = [{ valueType: ValueTypeName.Empty }];
                }
                else if (elementValueAndTypes.length > 1) {
                    elementTypeName = elementValueAndTypes.slice(1).reduce((existingType, valueAndType) => {
                        if (existingType == valueAndType.valueType) {
                            return existingType;
                        }
                        return ValueTypeName.Any;
                    }, elementValueAndTypes[0].valueType);
                }
                let values = elementValueAndTypes.map((valueAndType, i) => {
                    const datum = prop.data[i];
                    const valueType = valueAndType.valueType;
                    if (valueType == ValueTypeName.PropertySet) {
                        return new RecordValue(valueAndType.value, valueType);
                    }
                    else {
                        return new PrimitiveValue(valueAndType.structuredText, valueAndType.value, valueType, options);
                    }
                });
                if (values.length > 1 || asList) {
                    result[key] = new ResultProperty({ key, label: prop.name, value: new ListValue(values, elementTypeName) });
                }
                else if (values.length == 1) {
                    result[key] = new ResultProperty({ key, label: prop.name, value: values[0] });
                }
            }
            // TODO also augment the existing 
            else if ("properties" in prop) {
                const value = parsePropertiesFromPropertyDataSet(prop.properties);
                const keys = Object.keys(value);
                // this is wrapped as property
                if (keys.length == 1 && keys[0] == key) {
                    result[key] = value[key];
                }
                else {
                    result[key] = new ResultProperty({
                        key,
                        label: prop.name,
                        value: new RecordValue(value)
                    });
                }
                if (key == "mes:nested") {
                    // parse nested result
                    continue;
                }
            }
            if (shouldDuplicateResultProperty) {
                result[shouldDuplicateResultProperty] = result[key];
            }
        }
        return result;
    }
    class ResultPropertiesImpl {
        constructor(properties) {
            this.properties = properties;
        }
        get(key) {
            let prop = this.properties[key];
            if (!prop) {
                return;
            }
            // TOOD make sure that the type matches.
            // we can do this by matching the ValueTypeName
            return prop.value;
        }
        getPropertyType(key) {
            let prop = this.properties[key];
            if (!prop) {
                return;
            }
            return prop.value.valueTypeName;
        }
    }
    function addActionsToTextExtracts(resultProps) {
        var _a, _b, _c, _d;
        if (!resultProps) {
            return resultProps;
        }
        try {
            if (((_a = resultProps.textExtracts) === null || _a === void 0 ? void 0 : _a.value) && ((_b = resultProps.actions) === null || _b === void 0 ? void 0 : _b.value)) {
                for (const textExtract of (_c = resultProps.textExtracts) === null || _c === void 0 ? void 0 : _c.value) {
                    if (!textExtract.actions) {
                        textExtract.actions = resultProps.actions;
                    }
                    else {
                        (_d = console === null || console === void 0 ? void 0 : console.log) === null || _d === void 0 ? void 0 : _d.call(console, "textsnippet already has actions set, ignoring outer actions");
                    }
                }
            }
        }
        catch (e) {
            console.log('Could not add action to TextExtract', e);
        }
    }
    function createResultPropertiesFromPropertiesModel(model, options) {
        let resultProps = parsePropertiesFromPropertiesModel(model, options);
        addActionsToTextExtracts(resultProps);
        let resultPropertiesImpl = new ResultPropertiesImpl(resultProps);
        return new Proxy(resultPropertiesImpl, {
            get(target, key) {
                return target.properties[key];
            }
        });
    }
    function createResultPropertiesFromPropertiesData(properties) {
        let resultProps = parsePropertiesFromPropertyDataSet(properties);
        addActionsToTextExtracts(resultProps);
        let resultPropertiesImpl = new ResultPropertiesImpl(resultProps);
        return new Proxy(resultPropertiesImpl, {
            get(target, key) {
                return target.properties[key];
            }
        });
    }
    function parseLatexOnly(text) {
        if (!text)
            return "";
        return text
            .replace(/\$\$([\s\S]+?)\$\$/g, (_, expr) => katex_1.default.renderToString(expr, {
            displayMode: true,
            throwOnError: false,
        }))
            .replace(/\$([^$\n]+?)\$/g, (_, expr) => katex_1.default.renderToString(expr, {
            displayMode: false,
            throwOnError: false,
        }));
    }
    function parseTextRegionFromAnswerResultText(answerText) {
        return {
            typeName: "textregion",
            contextBefore: { plainText: answerText.context_before, structuredText: { content: (0, html_dom_parser_1.default)(parseLatexOnly(answerText.context_before)) } },
            text: { plainText: answerText.text, structuredText: { content: (0, html_dom_parser_1.default)(parseLatexOnly(answerText.text)) } },
            contextAfter: { plainText: answerText.context_after, structuredText: { content: (0, html_dom_parser_1.default)(parseLatexOnly(answerText.context_after)) } },
            textStartPos: answerText.text_start_pos,
            textEndPos: answerText.text_end_pos,
            startPage: answerText.text_start_page_number
        };
    }
});
/*
   Rendering via a templating
   
   There are three usages:
   - single values     {{title}} and {{{title}}}
   - repreated values  {{#mylist}} <span>{{.}}</span> {{/mylist}}
   - multiple values  {{#actions}}} {{url}} {{/actions}}
        
   
*/
/*
<script type="text/x-mustache-template" data-attr-role="group" data-attr-aria-labelledby="result_{{id}}" data-class-name="media mb-clickable-phone" data-attr-data-action-object="{ &quot;toggleOpen&quot;: { &quot;enabledSelector&quot;: &quot;.visible-phone&quot; }}">
  <span class="pull-left media-object {{^mes:thumbnail}}media-object-icon{{/mes:thumbnail}}" aria-hidden="true">
    {{#actions.data[0].value.href?}}<a href="{{actions.data[0].value.href}}" data-disabled-selector=".visible-phone" tabindex="-1">{{/actions.data[0].value.href?}}
    {{#icon?}}
      <img src="{{icon.href}}">
    {{/icon?}}
    {{^icon?}}
      <img src="../img/v2/mb-default-icon.svg" width="100px">
    {{/icon?}}
    {{#actions.data[0].value.href?}}
      <span class="mb-acc">{{category}} - {{#categoryclass?}}{{categoryclass}}{{/categoryclass?}}{{^categoryclass?}}{{extension}}{{/categoryclass?}}</span>
    </a>{{/actions.data[0].value.href?}}
  </span>
  <div class="media-body">
    <h3 class="media-heading" id="result_{{id}}">
      {{#actions.data[0].value.href?}}
        {{^mb:absoluteDocumentUrl?}}
            <a href="{{actions.data[0].value.href}}" data-disabled-selector=".visible-phone">
        {{/mb:absoluteDocumentUrl?}}
        {{#mb:absoluteDocumentUrl?}}
            <a data-action-object='{&quot;copyPath&quot;:{&quot;mb:absoluteDocumentUrl&quot;:&quot;{{mb:absoluteDocumentUrl}}&quot;}}' data-disabled-selector=".visible-phone">
        {{/mb:absoluteDocumentUrl?}}
      {{/actions.data[0].value.href?}}
      {{{title}}}
      {{#actions.data[0].value.href?}}
        <span class="mb-acc">{{category}} - {{#categoryclass?}}{{categoryclass}}{{/categoryclass?}}{{^categoryclass?}}{{extension}}{{/categoryclass?}}</span>
      </a>{{/actions.data[0].value.href?}}
    </h3>
    {{#mb:absoluteDocumentUrl?}}
      <div class="action mb-url-container mb-copy-path-hover" data-action-object='{&quot;copyPath&quot;:{&quot;mb:absoluteDocumentUrl&quot;:&quot;{{mb:absoluteDocumentUrl}}&quot;}}'>
        <div class='mb-copy-path-text'>
          <span role='button' tabindex='0'>{{{ mb:absoluteDocumentUrl }}}</span>
        </div>
        <i class="icon-copy mb-copy-path-hover-icon"></i>
        <span class="mb-acc">{{{i18n.copy_path_action}}}</span>
      </div>
    {{/mb:absoluteDocumentUrl?}}
    <ul class="mb-actions mb-separated hidden-phone mb-visible-open mb-no-print">
      {{#actions.data}} <li class="nowrap">{{{html}}}</li>{{/actions.data}}
      <li class="nowrap"><a role="button" class="action collect" tabindex="0" data-action-object="{&quot;collectResult&quot;:{}}">{{{i18n.Collect}}}</a></li>
    </ul>
    <dl class="mb-metadata mb-comma-separated-values mb-horizontal mb-separated hidden-phone mb-visible-open mb-small">
      <dt class="mb-acc">{{i18n.date}}</dt><dd>{{{mes:date}}}</dd>
      {{#mes:summary}}
        <dt>{{name}}</dt>{{#data}}<dd>{{#actions?}}<span class="mb-dropdown-toggle"><a data-action-object="{&quot;openMenu&quot;: {&quot;propertyId&quot;: &quot;{{property:id}}&quot;, &quot;position&quot;: {{data:position}} }}" class="nowrap">{{/actions?}}{{{html}}}{{#actions?}} <span class="caret"></span></a></span> {{/actions?}}</span></dd>{{/data}}
      {{/mes:summary}}
    </dl>
    {{#content}}
      <p class="mb-content">{{{.}}}</p>
    {{/content}}
    {{#mes:nested.data?}}
      <ul class="mb-nested">
        {{#mes:nested}}
          <div class="media mb-nested" data-action-object="{ &quot;toggleOpen&quot;: { &quot;enabledSelector&quot;: &quot;.visible-phone&quot; }}">
            {{#actions.data[0].value.href?}}
              <a href="{{actions.data[0].value.href}}" data-disabled-selector=".visible-phone">
            {{/actions.data[0].value.href?}}
              <b>{{{title}}}</b>
            {{#actions.data[0].value.href?}}
              </a>
            {{/actions.data[0].value.href?}}
            <ul class="mb-actions mb-separated hidden-phone mb-visible-submenu-open mb-no-print">
              {{#actions.data}} <li class="nowrap"><small>{{{html}}}</small></li>{{/actions.data}}
            </ul>
            <dl class="mb-comma-separated-values mb-separated mb-summarized-description-list mb-small"><dd>{{{mes:date}}}</dd></dl>
          </div>
        {{/mes:nested}}
      </ul>
    {{/mes:nested.data?}}
    <span class="clearfix"></span>
  </div>
</script>
*/
